<demo-section [name]="name" [src]="src" [componentContent]="componentContent">
  <p>Displays collapsible content panels for presenting information in a limited amount of space</p>
  <p>The <strong>accordion component</strong> builds on top of the collapse directive to provide a list
  of items, with collapsible bodies that are collapsed or expanded by clicking on the item's header.</p>
  <p>The easiest way to add an accordion component to your app (will be added to the root module)</p>
  <pre class="prettyprint lang-bash prettyprinted"><span class="pln">ng add ngx</span><span class="pun">-</span><span class="pln">bootstrap </span> --component <span class="pln">accordion</span></pre>
  <docs-section [content]="componentContent"></docs-section>
</demo-section>
